export enum AuthHttpHeader {
  XLocation = 'x-location'
}